export default 0.0019;
